<div class="card">
  <div class="card-header card-header-btn">
    <div class="card-title">
      <i class="fa fa-phone" aria-hidden="true"></i> Telefones
    </div>
    <div class="card-actions">
      <button type="button" (click)="newPhone($event)">
        <i class="fa fa-plus" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="card-block p-1">
    <div class="list-group list-group-flush scrolly" *ngIf="phoneList.length > 0; else tmpMsg">
      <div class="list-group-item flex-column align-items-start" *ngFor="let phone of phoneList"
        [formGroup]="phone">
        <div class="d-flex full-width">
          <input class="form-control number" placeholder="Informe o número" formControlName="number">
          <select class="form-control type" formControlName="phone_type">
            <option value="C">Celular</option>
            <option value="F">Fixo</option>
          </select>

          <div class="d-flex">
            <button type="button" class="btn btn-xs btn-outline-secondary btn-sm mr-1 width-34"
              title="Definir como principal" [class.btn-outline-success]="phone.value.primary"
              (click)="setPrimary($event, phone)">
              <span class="fa fa-check" aria-hidden="true"></span>
            </button>
            <button type="button" class="btn btn-xs btn-outline-secondary btn-sm mr-1 width-34" title="Tem Whatsapp?"
              [class.btn-outline-success]="phone.value.whatsapp" (click)="toggle($event, phone, 'whatsapp')">
              <span class="fab fa-whatsapp" aria-hidden="true"></span>
            </button>
            <button type="button" class="btn btn-xs btn-outline-secondary btn-sm mr-1 width-34"
              title="Pode receber notificações" *ngVar="phone.value.send_notification as note"
              [class.btn-outline-success]="note" (click)="toggle($event, phone, 'send_notification')">
              <span class="far" [ngClass]="{'fa-bell-slash': !note, 'fa-bell': note}" aria-hidden="true"></span>
            </button>
            <button type="button" class="btn btn-xs btn-outline-secondary btn-sm mr-1 width-34" title="Remover Telefone"
              (click)="removePhone($event, phone)">
              <span class="fas fa-times" aria-hidden="true"></span>
            </button>
          </div>
        </div>
        <input class="form-control obs" placeholder="Observação" formControlName="obs">
      </div>
    </div>

    <ng-template #tmpMsg>
      <div class="col-md text-center">Informe um Telefone</div>
    </ng-template>
  </div>
</div>
